export default {
    name:'number',
    format: (v) => {
        return v ? Number(v).toFixed(4) : '0.0000'
    }
}